import { render, staticRenderFns } from "./Fluxity.vue?vue&type=template&id=23d997a2&scoped=true"
import script from "./Fluxity.vue?vue&type=script&lang=js"
export * from "./Fluxity.vue?vue&type=script&lang=js"
import style0 from "./Fluxity.vue?vue&type=style&index=0&id=23d997a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d997a2",
  null
  
)

export default component.exports